var lastScrollTop = 0;
let header = document.querySelector("header");
let menuButton = document.querySelector(".header__content--menu");
let paneMenu = document.querySelector(".header__content--pane-menu");
// Chờ tài liệu DOM tải hoàn toàn trước khi tương tác với nó
document.addEventListener("DOMContentLoaded", ()=>{
    header = document.querySelector("header");
    menuButton = document.querySelector(".header__content--menu");
    paneMenu = document.querySelector(".header__content--pane-menu");
    if (header && menuButton && paneMenu) {
        window.addEventListener("scroll", ()=>{
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (scrollTop > lastScrollTop) // Cuộn xuống, ẩn header
            header.classList.add("hide");
            else // Cuộn lên, hiện header
            header.classList.remove("hide");
            lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // Tránh vị trí cuộn âm
        });
        menuButton.addEventListener("click", ()=>{
            paneMenu.style.left = paneMenu.style.left === "0px" ? "-350px" : "0px";
        });
    } else console.error("M\u1ED9t ho\u1EB7c nhi\u1EC1u ph\u1EA7n t\u1EED c\u1EA7n thi\u1EBFt kh\xf4ng t\xecm th\u1EA5y.");
});

//# sourceMappingURL=index.e0a6c85e.js.map
